import {
  mdiAccountSupervisor, mdiCog, mdiDatabaseExport,
} from '@mdi/js'

export default [
  {
    title: 'Configuración',
    icon: mdiCog,
    children: [
      {
        icon: mdiAccountSupervisor,
        title: 'Usuarios',
        to: 'config-users',
      },
      {
        icon: mdiDatabaseExport,
        title: 'Data',
        to: 'data-view',
      },
    ],
  },
]
